import {request} from '@/assets/js/api/_helpers'

const ENDPOINT_REQUESTS_MONEY_COMPENSATIONS = '/api/requests/matching/money/compensations'


export default {
    list: (config) => request( 'GET', ENDPOINT_REQUESTS_MONEY_COMPENSATIONS, config),
    movement: ({id, ...config}) => request( 'POST', `${ENDPOINT_REQUESTS_MONEY_COMPENSATIONS}/${id}/movement`, config),
    retrieve: ({id, ...config}) => request( 'GET', `${ENDPOINT_REQUESTS_MONEY_COMPENSATIONS}/${id}`, config),
}